import { combineReducers } from 'redux';
import { userReducer } from './UserReducer';
import { formReducer } from './FormReducer';

const reducers = combineReducers({
    userReducer,
    formReducer
});

export default reducers;